import {
  docxConversionNotFoundResponseSchema,
  docxConversionStatusResponseSchema,
} from 'xosign-types';
import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

const statusRequestSchema = z.object({
  conversionId: z.string(),
});

const endpoints = {
  'docxConversion.status': {
    method: 'GET',
    url: `${API_URL_BASE}docx-conversion/:conversionId/status`,
    requestSchema: statusRequestSchema,
    responseSuccessSchema: docxConversionStatusResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      404: docxConversionNotFoundResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof statusRequestSchema,
    typeof docxConversionStatusResponseSchema,
    {
      404: typeof docxConversionNotFoundResponseSchema;
    }
  >,
};

export default endpoints;
